import { computed, useAttrs } from 'vue';
import type { ClassValue } from 'tailwind-variants';

/**
 * A component's fallthrough attributes, split for `inheritAttrs: false`:
 * `className` goes into the component's own `tv()` call, so a consumer class
 * that conflicts with a default (`rounded-full` on a `rounded-md` button)
 * replaces it instead of racing it in stylesheet order; `attrs` is everything
 * else, for `v-bind` on the element that should receive it.
 */
export const useRootAttrs = () => {
  const allAttrs = useAttrs();

  const className = computed(() => allAttrs.class as ClassValue);
  const attrs = computed(() => {
    const { class: _class, ...rest } = allAttrs;

    return rest;
  });

  return { className, attrs };
};
